import React, {Fragment} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";
import DropZone from "../../../../share-components/upload/dropzone";

const WhyYouLoveItForm = (props) => {
    const {errors, register, setValue, getValues} = props;
    const currentIcon = getValues ? getValues('icon_url') : null;
    const isEdit = getValues ? !!getValues('id') : false;

    const onChangeFile = (acceptedFiles) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            setValue('icon', acceptedFiles, {shouldValidate: true});
        }
    };

    return (
        <Fragment>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Title<span style={{color: "red"}}>*</span></Label>
                        <input name="title" type="text" {...register('title')} className={`form-control ${errors.title ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.title?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Icon{!isEdit && <span style={{color: "red"}}>*</span>}</Label>
                        {currentIcon && (
                            <div className="mb-2">
                                <img src={currentIcon} alt="" style={{width: 48, height: 48, objectFit: 'contain'}}/>
                            </div>
                        )}
                        <DropZone
                            onChangeFile={onChangeFile}
                            extension="image/*"
                            multiple={false}
                            placeholder="Upload or drop an icon here"
                        />
                        {isEdit && <small className="text-muted">Leave blank to keep the current icon</small>}
                        {errors.icon && <div className="text-danger mt-1">{errors.icon?.message}</div>}
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    );
};

export default WhyYouLoveItForm;
